export default "/assets/site/images/labdas.jpg?959d4c24089a5fffc6363f19a0eb928a";